import { get } from 'lodash';
import { getConfig } from '../config/portal';
import messages from './translationMessages';

export const getEnabledFacets = () => {
  return get(getConfig(), 'pages.partySearch.facets', []).map(facet => facet.name);
};

export const getPartySearchFormImage = () => {
  return get(getConfig(), 'pages.partySearch.backgroundFormImage', '');
};

export const getPartySearchRadii = () => {
  const radiusConfig = getConfig().pages.partySearch.facets.find(facet => facet.name === 'distance');
  return get(radiusConfig, 'radii', []);
};

export const getPartySearchDefaultRadius = () => {
  const radiusConfig = getConfig().pages.partySearch.facets.find(facet => facet.name === 'distance');
  return get(radiusConfig, 'defaultRadius', '');
};

export const getPartySearchPageSize = () => {
  return getConfig().pages.partySearch.pagination.pageSize;
};

export const getPartySearchPageHorizon = () => {
  return getConfig().pages.partySearch.pagination.pageHorizon;
};

export const getPartySearchSortOptions = () => {
  return getConfig().pages.partySearch.sort.options;
};

export const getPartySearchSortDefaultValue = () => {
  return getConfig().pages.partySearch.sort.default;
};

export const getFilterRegionSortDefaultValue = () => {
  return getConfig().pages.partySearch.quickFilterRegion.defaultSort;
};

export const getFilterRegionOrder = () => {
  return getConfig().pages.partySearch.quickFilterRegion.order;
};

export const getDefaultParams = () => ({
  pageSize: getPartySearchPageSize(),
  page: 1,
  partySearch: true,
  sort: getPartySearchSortDefaultValue()
});

export const SORT_NAME_MAP = {
  'proximity-asc': messages.searchHeader.sort.nearest,
  'proximity-desc': messages.searchHeader.sort.farthest,
  'displayName-asc': messages.searchHeader.sort.nameAsc,
  'displayName-desc': messages.searchHeader.sort.nameDesc
};

export const getPartySearchValidParams = () => {
  return getConfig().pages.partySearch.params;
};

export const getPartySearchTrackingMapping = (type, value) => {
  const sortMapping = get(getConfig(), `pages.partySearch.analytics.mapping.${type}`, []);
  const entry = sortMapping.find(({key}) => key === value);
  return get(entry, 'value');
};
